import { render, staticRenderFns } from "./DocumentoAereo.vue?vue&type=template&id=4ece7348&scoped=true"
import script from "./DocumentoAereo.vue?vue&type=script&lang=js"
export * from "./DocumentoAereo.vue?vue&type=script&lang=js"
import style0 from "./DocumentoAereo.vue?vue&type=style&index=0&id=4ece7348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece7348",
  null
  
)

export default component.exports